import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AboutStatItem } from '../../about.models';

@Component({
  selector: 'app-about-unique-section',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './about-unique-section.component.html',
  styleUrl: './about-unique-section.component.scss'
})
export class AboutUniqueSectionComponent {
  @Input({ required: true }) uniqueStats: AboutStatItem[] = [];
}
